import Filters from 'library/components/filters';
import Loader from 'library/components/entity-loader';
import Search from 'library/components/search';
import Image from 'library/components/image';
import withModalContainer from '../hocs/with-modal-container';
import {
  CatalogueContainer,
  CheckIcon,
  ExitingItem,
  ImageContainer,
  ExitingItemsContainer,
} from './styled';
import NoContent from '../../no-content';

const Catalogue = ({
  data = [],
  isLoading,
  hasMore = false,
  onLoadMore,
  onReset,
  onFilterChange,
  onQueryParamDelete,
  onSuggestionSelect,
  onSuggestionsReset,
  isSuggestionLoading,
  filters,
  query,
  suggestions,
  selectedIds,
  onChange,
  noContentMessage = 'Nothing to display',
}) => {
  const renderItem = ({ id, images = [], name }) => {
    const [image] = images;

    const handleChange = () => {
      onChange(id);
    };

    return (
      <ExitingItem key={id} isSelected={selectedIds.includes(id)} onClick={handleChange}>
        <ImageContainer>
          <Image isCover id={id} source={image} width={40} />
        </ImageContainer>
        <span>{name}</span>
        <CheckIcon className={selectedIds.includes(id) ? 'icon-check-selected' : 'icon-check'} />
      </ExitingItem>
    );
  };

  return (
    <CatalogueContainer>
      <Search
        hideOverlay
        queryParameter="query"
        onSelect={(element) => {
          if (element.type === 'query') {
            onFilterChange({ query: element.name });
          } else {
            onSuggestionSelect(element);
          }
        }}
        onReset={onSuggestionsReset}
        options={suggestions}
        loading={isSuggestionLoading}
        placeholder="Find an item"
        types={['item']}
      />
      <Filters
        showType={false}
        filters={filters}
        isShown
        isSetOptionsContent
        hasAdditionalSortOptions={false}
        baseQuery={query}
        onChange={onFilterChange}
        onReset={onReset}
        onDelete={onQueryParamDelete}
        isQueryFilterSibling={false}
      >
        <ExitingItemsContainer>
          {data.map(renderItem)}
          <Loader
            isLoading={isLoading}
            currentAmount={data.length}
            hasMore={hasMore}
            onScroll={onLoadMore}
            onReset={onReset}
          />
          {data.length === 0 && !isLoading ? (
            <NoContent
              title={noContentMessage}
            />
          ) : null}
        </ExitingItemsContainer>
      </Filters>
    </CatalogueContainer>
  );
};
export default withModalContainer(Catalogue);
